import {Utils} from 'hasta-la-vista-ui-core'
import {AuthService, MovieService, RegionService} from 'hasta-la-vista-middleware-api/service'
import {UAParser}	from 'ua-parser-js'
import MetaData from  '../../../mixins/meta-data.js'

export default {

	mixins: [MetaData],

	data() {
		return {
			selected_cinema: null,
			selected_region: null,
			regions: null,
			filtered_regions: null,
			availableCinemas: [],
			cinemasByRegion: [],
			allowedRegions: null,
			cinemasNearby: null,
            injected_regions: null,
            loading: true,
		}
	},

	methods: {
		setCinemasByRegion(raw_regions, filter_cinemas = null) {
            var allowedRegions = []

            if(raw_regions && raw_regions != null && raw_regions != undefined) {

                if(typeof raw_regions == "object" && Object.keys(raw_regions).length) {

                    allowedRegions = raw_regions.map((r)=> {
                        let cinemas = r.cinemas.filter((c)=>~this.availableCinemas.indexOf(c.id.toString()) || this.availableCinemas.length == 0);
                        return {
                            id: r.id,
                            name: r.name,
                            cinemas
                        };
                    }).filter((r)=>r.cinemas.length > 0)
                }
            }

            let regions = []
            if(filter_cinemas != null) {
                if(Object.keys(filter_cinemas).length > 0) {
                    let sorted_filter_cineams = null
                    let sorted_regions = null
                    filter_cinemas = MovieService.filterCinemasToRegionModel(filter_cinemas, allowedRegions)
                    sorted_filter_cineams = MovieService.sortfilteredCinemasByDistance(filter_cinemas)
                    // console.log("sorted_filter_cineams", sorted_filter_cineams)
                    sorted_regions = MovieService.sortRegionsByDistance(allowedRegions)
                    // console.log("sorted_regions", sorted_regions)
                    if(sorted_filter_cineams != null && sorted_filter_cineams != undefined) {
                        regions = [{name: 'Cinemas', cinemas: sorted_filter_cineams}]
                    }

                    if(this.cinemasNearby != null) {
                        regions = [{name: 'Cinemas Nearby', cinemas: this.cinemasNearby}].concat(regions)
                    }
                }
            } else {
                regions = allowedRegions
                if(this.cinemasNearby != null) {
                    regions = [{name: 'Cinemas Nearby', cinemas: this.cinemasNearby}].concat(regions)
                }
            }

            this.cinemasByRegion = regions
        },

        filterRegionsAndCinemas() {
        	if(!this.selected_cinema || this.selected_cinema == null) {
        		this.filtered_regions = this.regions
        		window.history.pushState({}, null, "/find-cinemas")
            	this.$router.push("/find-cinemas")
        		return true
        	} else {
        		let tmp_region = [];
        		let tmp_cinema = null;

				for(let i = 0; i<=this.regions.length; i++) {
					// console.log(this.regions[i])
					if(this.regions[i] != undefined) {
						if(this.regions[i].cinemas != undefined) {
							for(let c = 0; c <= this.regions[i].cinemas.length; c++) {
								if(this.regions[i].cinemas[c] != undefined) {
									if(this.regions[i].cinemas[c].id == this.selected_cinema.id) {

										tmp_region.push(this.regions[i])
										tmp_cinema = this.regions[i].cinemas[c]

										tmp_region[0].cinemas = new Array()
										tmp_region[0].cinemas.push(tmp_cinema)

										this.filtered_regions = tmp_region

										console.log("filterred regions", tmp_region)
										this.setURL()
										return true
									}
								}
							}
						}
					}
				}

				this.filtered_regions = this.regions

				return true
        	}
        },

        setURL() {
        	if(this.selected_cinema || this.selected_cinema != null) {
        		let path = window.location.path

        		console.log("URL path",path)

        		let newPath = "/find-cinemas/"+this.selected_cinema.slug

        		console.log("new URL path",newPath)

        		if(path == undefined || path != newPath) {


        			window.history.pushState({}, null, newPath)
            		this.$router.push(newPath)
        		}
        	}
        }
	},

	created() {
		Promise.all([RegionService.getRegions()]).then(([regions])=> {
			if(regions.data) {
				this.regions = regions.data
	            this.loading = false

				if(this.$route.params.cinema && this.$route.params.cinema != undefined && this.$route.params.cinema != null) {
					console.log("route cinema", this.$route.params.cinema)
	                this.loading = true

					Promise.all([RegionService.getCinemaBySlug(this.$route.params.cinema)]).then(([selected_cinema]) => {
	                    this.selected_cinema = selected_cinema
	                    this.filterRegionsAndCinemas();
	                    this.setCinemasByRegion(regions.data)
	                    this.loading = false
					});
	    		} else {
				     if(this.selected_cinema) {

				     } else {
					    this.filtered_regions = regions.data;
				        this.setCinemasByRegion(regions.data)
					}
				}
			}
		})
	},

    mounted() {
		window.scroll({top: 0, left: 0})
        if (window.__PRERENDER_INJECTED) {
            if(window.__PRERENDER_INJECTED.regions) {
                let injected_regions = RegionService.setPreRenderRegions(window.__PRERENDER_INJECTED.regions)
                this.selected_cinema = RegionService.getCinemaBySlug(this.$route.params.cinema)
                if(this.selected_cinema) {
                    this.metaTitle = this.selected_cinema.name;
                    this.metaDescription = 'View information about ' + this.selected_cinema.name + ' at Ster-Kinekor';
                    this.metaCanonicalURL = "https://www.sterkinekor.com/find-cinemas/"+this.selected_cinema.slug
                }

                this.injected_regions = injected_regions
                this.regions = injected_regions.data
                if(this.regions != undefined && this.regions != null) {
                    this.setCinemasByRegion(this.regions);
                    this.filterRegionsAndCinemas();
                }
            } else {
                injected_regions = undefined
            }
        }
    },

	watch: {
        selected_cinema: {
            handler: Utils.debounce(function() {
                this.metaTitle = this.selected_cinema.name;
                this.metaDescription = 'View information about ' + this.selected_cinema.name + ' at Ster-Kinekor';
                this.metaCanonicalURL = "https://www.sterkinekor.com/find-cinemas/"+this.selected_cinema.slug
                this.$emit('updateHead');
                this.filterRegionsAndCinemas();
            }, 300)
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/cinemas/cinemas.js